<template>
  <el-dialog
    :title="$t('workflowSettingDialog.title')"
    :visible.sync="visible"
    width="650px"
    custom-class="workflow-setting-dialog"
    :close-on-click-modal="false"
    :show-close="true"
    @close="handleClose"
  >
    <div class="dialog-body">
      <!-- 流程名称 -->
      <div class="form-row">
        <div class="form-label">{{ $t('workflowSettingDialog.flowName') }}:</div>
        <div class="form-content">
          <el-input
            v-model="formData.flowName"
            size="small"
            :placeholder="$t('workflowSettingDialog.flowNamePlaceholder')"
            class="form-input"
            disabled
          />
        </div>
      </div>

      <!-- 流程说明 -->
      <div class="form-row">
        <div class="form-label">{{ $t('workflowSettingDialog.description') }}:</div>
        <div class="form-content">
          <el-input
            v-model="formData.describle"
            type="textarea"
            size="small"
            :placeholder="$t('workflowSettingDialog.descriptionPlaceholder')"
            :rows="3"
            class="form-input"
          />
        </div>
      </div>

      <!-- 提交者结束 -->
      <div class="form-row">
        <div class="form-label">{{ $t('workflowSettingDialog.submitterEnd') }}:</div>
        <div class="form-content">
          <el-select
            v-model="formData.startNodeFinish"
            size="small"
            class="form-input"
          >
            <el-option :label="$t('workflowSettingDialog.yes')" value="Y" />
            <el-option :label="$t('workflowSettingDialog.no')" value="N" />
          </el-select>
        </div>
      </div>

      <!-- 流程步骤 -->
      <div class="form-row">
        <div class="form-label">{{ $t('workflowSettingDialog.flowSteps') }}:</div>
        <div class="form-content steps-content">
          <div class="add-step-bar" @click="addWorkflowStep">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 1V13M1 7H13" stroke="#0E76FF" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span class="add-step-text">{{ $t('workflowSettingDialog.addStep') }}</span>
          </div>

          <!-- 步骤列表 -->
          <div
            v-for="(item, index) in formData.steps"
            :key="index"
            class="step-card"
          >
            <div class="step-card-inner">
              <span class="step-number">{{ $t('workflowSettingDialog.step') }} {{ index + 1 }}</span>
              <div class="step-fields">
                <div class="step-field-group">
                  <el-select
                    v-model="item.staffId"
                    size="small"
                    :placeholder="$t('workflowSettingDialog.selectStaff')"
                    class="step-input"
                    @change="onStaffChange(item)"
                  >
                    <el-option
                      v-for="staff in committeeMembers"
                      :key="staff.id || staff.committeeId || staff.memberId || staff.userId"
                      :label="staff.name || staff.memberName || staff.userName || staff.ownerName || staff.staffName"
                      :value="staff.id || staff.committeeId || staff.memberId || staff.userId"
                    />
                  </el-select>
                </div>
                <div class="step-radios">
                  <label class="step-radio">
                    <input type="radio" :name="`step-type-${index}`" value="2" v-model="item.type" @change="chooseType(item)" />
                    <span class="radio-text">{{ $t('workflowSettingDialog.normalFlow') }}</span>
                  </label>
                  <label class="step-radio" v-if="index !== 0">
                    <input type="radio" :name="`step-type-${index}`" value="1" v-model="item.type" @change="chooseType(item)" />
                    <span class="radio-text">{{ $t('workflowSettingDialog.countersign') }}</span>
                  </label>
                </div>
                <div class="step-delete" @click="deleteStep(item)">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3L11 11M11 3L3 11" stroke="#8C9BB4" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <el-button
                  v-if="item.type == '1'"
                  size="mini"
                  class="step-add-staff-btn"
                  @click="addStaff(item)"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 1V13M1 7H13" stroke="#8C9BB4" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  {{ $t('workflowSettingDialog.addStaff') }}
                </el-button>
              </div>
            </div>

            <!-- 会签子人员 -->
            <div v-for="(subItem, subIndex) in item.subStaff" :key="subIndex" class="sub-staff-row">
              <el-select
                v-model="subItem.staffId"
                size="small"
                :placeholder="$t('workflowSettingDialog.selectStaff')"
                class="step-input"
                @change="onStaffChange(subItem)"
              >
                <el-option
                  v-for="staff in committeeMembers"
                  :key="staff.id || staff.committeeId || staff.memberId || staff.userId"
                  :label="staff.name || staff.memberName || staff.userName || staff.ownerName || staff.staffName"
                  :value="staff.id || staff.committeeId || staff.memberId || staff.userId"
                />
              </el-select>
              <el-button
                size="mini"
                class="step-add-staff-btn"
                @click="addStaff(item)"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 1V13M1 7H13" stroke="#8C9BB4" stroke-width="2" stroke-linecap="round"/>
                </svg>
                {{ $t('workflowSettingDialog.addStaff') }}
              </el-button>
              <div class="step-delete" @click="deleteStaff(item, subItem)">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 3L11 11M11 3L3 11" stroke="#8C9BB4" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="btn-back" @click="handleClose">{{ $t('workflowSettingDialog.back') }}</el-button>
      <el-button class="btn-submit" :loading="submitting" @click="saveWorkflowSettingInfo">{{ $t('workflowSettingDialog.submit') }}</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { listOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import {
  getWorkflowSteps,
  updateWorkflow
} from '@/api/system/workflowSettingManageApi'

export default {
  name: 'WorkflowSettingDialog',
  components: {},
  data() {
    return {
      visible: false,
      submitting: false,
      communityId: '',
      committeeMembers: [],
      formData: {
        flowId: '',
        flowName: '',
        flowType: '',
        describle: '',
        startNodeFinish: 'Y',
        steps: []
      },

    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    generateId() {
      return `id-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`
    },

    open(row) {
      if (!row || !row.flowId) {
        this.$message.error(this.$t('workflowSettingDialog.invalidOperation'))
        return
      }
      if (row.communityId) {
        this.communityId = row.communityId
      }
      this.formData = {
        flowId: row.flowId,
        flowName: row.flowName || '',
        flowType: row.flowType || '',
        describle: '',
        startNodeFinish: 'Y',
        steps: []
      }
      this.visible = true
      this.loadCommitteeMembers()
      this.loadSteps()
    },

    async loadSteps() {
      try {
        const { data } = await getWorkflowSteps({
          communityId: this.communityId,
          flowId: this.formData.flowId
        })
        this._freshResStep(data)
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    _freshResStep(data) {
      if (!data) {
        this.formData.steps = []
        return
      }
      this.formData.describle = data.describle || ''
      if (data.startNodeFinish) {
        this.formData.startNodeFinish = data.startNodeFinish
      }
      const workflowSteps = Array.isArray(data.workflowSteps) ? data.workflowSteps : []
      const steps = workflowSteps.map((step, index) => {
        const staffList = Array.isArray(step.workflowStepStaffs) ? step.workflowStepStaffs : []
        const mainStaff = staffList[0] || {}
        const subStaff = staffList.slice(1).map(staff => ({
          id: staff.id || this.generateId(),
          staffId: staff.staffId || staff.userId || '',
          staffName: staff.staffName || staff.userName || staff.name || '',
          staffRole: staff.staffRole || ''
        }))
        return {
          seq: index,
          staffId: mainStaff.staffId || mainStaff.userId || '',
          staffName: mainStaff.staffName || mainStaff.userName || mainStaff.name || '',
          staffRole: mainStaff.staffRole || '',
          type: String(step.type || '2'),
          subStaff
        }
      })
      this.formData.steps = steps
    },

    addWorkflowStep() {
      const step = {
        seq: this.formData.steps.length,
        staffId: '',
        staffName: '',
        type: '2',
        subStaff: []
      }
      this.formData.steps.push(step)
    },

    async loadCommitteeMembers() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        const communityList = res.data || []
        const communityIds = communityList.map(c => c.communityId).join(',')
        const { data } = await listOwnerCommittee({
          communityIds,
          page: 1,
          row: 1000
        })
        this.committeeMembers = Array.isArray(data) ? data : (data && data.records ? data.records : [])
      } catch (error) {
        console.error('Failed to load committee members:', error)
        this.committeeMembers = []
      }
    },

    onStaffChange(item) {
      const staffId = item.staffId
      const staff = this.committeeMembers.find(s => String(s.id || s.committeeId || s.memberId || s.userId) === String(staffId))
      if (staff) {
        this.$set(item, 'staffName', staff.name || staff.memberName || staff.userName || staff.ownerName || staff.staffName)
      }
    },

    _getStaffFromType() {
      const type = this.formData.flowType
      if (['30003', '40004', '70007', '80008'].includes(type)) return 'purchase'
      if (['50005', '60006'].includes(type)) return 'contract'
      return ''
    },

    deleteStep(step) {
      this.formData.steps = this.formData.steps.filter(s => s.seq !== step.seq)
    },

    addStaff(step) {
      step.subStaff.push({
        id: this.generateId(),
        staffId: '',
        staffName: '',
        staffRole: '1001'
      })
    },

    deleteStaff(step, subStaff) {
      step.subStaff = step.subStaff.filter(s => s.id !== subStaff.id)
    },

    chooseType(item) {
      if (item.type === '1') {
        item.subStaff = []
      }
    },

    async saveWorkflowSettingInfo() {
      try {
        this.submitting = true
        await updateWorkflow({
          ...this.formData,
          communityId: this.communityId
        })
        this.$message.success(this.$t('workflowSettingDialog.saveSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.submitting = false
      }
    },

    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
/* 表单行 */
.dialog-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: flex;
  align-items: center;
}

.form-label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
  line-height: 38px;
  text-align: right;
  margin-right: 12px;
  white-space: nowrap;
}

.form-content {
  flex: 1;
  margin-left: 0;
}

.form-input {
  width: 100%;
}

.form-input >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
  color: #1D2129;
}

.form-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.form-input >>> .el-input__inner:disabled {
  background: #F1F6FA;
  color: #8C9BB4;
}

.form-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
  font-family: 'Inter', 'PingFang SC';
}

.form-input >>> .el-textarea__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  font-size: 14px;
  background: white;
  color: #1D2129;
  padding: 10px 16px;
}

.form-input >>> .el-textarea__inner:focus {
  outline-color: #0E76FF;
}

.form-input >>> .el-textarea__inner::placeholder {
  color: #8C9BB4;
  font-family: 'Inter', 'PingFang SC';
}

/* 步骤区域 */
.steps-content {
  flex: 1;
}

.add-step-bar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 38px;
  background: white;
  border-radius: 10px;
  outline: 1px #0E76FF solid;
  outline-offset: -1px;
  cursor: pointer;
  margin-bottom: 12px;
}

.add-step-bar:hover {
  background: rgba(14, 118, 255, 0.04);
}

.add-step-text {
  font-size: 14px;
  font-weight: 500;
  color: #0E76FF;
  font-family: 'PingFang SC';
}

/* 步骤卡片 */
.step-card {
  background: #F3F7FB;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 8px;
}

.step-card-inner {
  display: flex;
  align-items: center;
  gap: 12px;
}

.step-number {
  font-size: 14px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
  white-space: nowrap;
  flex-shrink: 0;
}

.step-fields {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  flex-wrap: wrap;
}

.step-field-group {
  flex-shrink: 0;
}

.step-input {
  width: 141px;
}

.step-input >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
  color: #1D2129;
  cursor: pointer;
}

.step-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.step-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
  font-family: 'Inter', 'PingFang SC';
}

.step-input-icon {
  color: #8C9BB4;
}

.step-radios {
  display: flex;
  align-items: center;
  gap: 16px;
}

.step-radio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #1D2129;
  font-family: 'PingFang SC';
  font-weight: 500;
  white-space: nowrap;
}

.step-radio input[type="radio"] {
  accent-color: #0E76FF;
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.step-delete {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 10px;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  cursor: pointer;
  flex-shrink: 0;
}

.step-delete:hover {
  outline-color: #0E76FF;
}

.step-delete:hover svg path {
  stroke: #FB2C36;
}

.step-add-staff-btn {
  height: 38px;
  border-radius: 10px !important;
  background: white !important;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  border: none !important;
  color: #8C9BB4 !important;
  font-size: 13px;
  font-weight: 400;
  font-family: 'PingFang SC';
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.step-add-staff-btn:hover {
  outline-color: #0E76FF;
  color: #0E76FF !important;
}

.step-add-staff-btn:hover svg path {
  stroke: #0E76FF;
}

/* 子人员 */
.sub-staff-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  margin-left: 57px;
}

/* 底部按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-back {
  width: 98px;
  height: 38px;
  border-radius: 10px !important;
  background: white !important;
  color: #0E76FF !important;
  border: 1px #0E76FF solid !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0;
}

.btn-submit {
  width: 98px;
  height: 38px;
  border-radius: 10px !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0;
}

.btn-submit:hover {
  background: #1C99FF !important;
}
</style>

<!-- Unscoped styles for el-dialog which is appended to body -->
<style>
.workflow-setting-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.workflow-setting-dialog .el-dialog__header {
  height: 66px;
  box-sizing: border-box;
  padding: 22px 24px;
  background: #EBF2FA;
  border-bottom: 1px solid #DCE6F5;
}

.workflow-setting-dialog .el-dialog__title {
  font-size: 16px;
  color: #1D2129;
  font-weight: 600;
  font-family: 'PingFang SC';
}

.workflow-setting-dialog .el-dialog__body {
  padding: 24px 24px 8px;
}

.workflow-setting-dialog .el-dialog__footer {
  padding: 8px 24px 28px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
